import { AfterViewInit, Component, OnInit, TemplateRef } from '@angular/core';
import { PlaylistService } from '../../services/playlist.service';
import { UtilService } from '../../services/util.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { MessageService } from '../../services/message.service';
import { Constant } from '../../services/data';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthentictionService } from '../../services/authentiction.service';
import { MovieService } from '../../services/movie.service';
import { SeriesService } from '../../services/series.service';
import { LivestreamService } from '../../services/livestream.service';
declare var bootstrap: any;

@Component({
  selector: 'app-play-list',
  templateUrl: './play-list.component.html',
  styleUrls: ['./play-list.component.css']
})
export class PlayListComponent implements OnInit ,AfterViewInit{
  
  playListModal: any = {
    type: 'fromUrl',
    name: '',
    userName: '',
    password: '',
    url: ''
  };

  playList: any = [];
  filterPlayList:any =[];
  xstreamList: any;
  isLoading: boolean = false;
  
  bsModalRef: BsModalRef;
  // url_pattern = "([a-z0-9-]+\:\/+)([^\/\s]+)([a-z0-9\-@\^=%&;\/~\+]*)[\?]?([^ \#\r\n]*)#?([^ \#\r\n]*)";
  url_pattern = "(https?:\/\/)([a-zA-Z0-9.-]+)(\/[^\s?#]*)?(\?[^\s#]*)?(#[^\s]*)?"
  // XuserId: any;
  userid: any
  type='password';
  showCloudUpload:any;
  editModel: any = {};
  isLogin:boolean = false;
  progress = 0;
  totalTasks = 6;
  loadingItems = [
  { label: 'Live TV', loaded: false, progress: 0 },
  { label: 'Movies', loaded: false, progress: 0 },
  { label: 'Series', loaded: false, progress: 0 }
];

overallProgress = 0;
currentLabel = '';
isLoadingdb:boolean = false;

  constructor(private moviesService:MovieService,private seriesService:SeriesService,private livetvService:LivestreamService,private authService:AuthentictionService,private utilService: UtilService, private playlistService: PlaylistService, private modalService: BsModalService, private messageService: MessageService, private router: Router) {
  }

  ngOnInit(): void {
    
  }
  ngAfterViewInit(): void {
    const UserData = JSON.parse(this.utilService.getFullUserId()) || '' ;
    const uToken = (this.utilService.getValueCookie(Constant.USERTOKEN)) || '';
    if(uToken){
      this.isLogin = true;
    }else{
      this.isLogin = false;
    }
    this.userid = UserData.user_id
    // this.playListModal.type = "onestreamUrl"
    if (this.userid) {
      setTimeout(() => {
        this.getPlayList();
      }, 500);
    }else {
      this.getLocalPlaylist()
    }
  }

  getPlayList() {
    this.playList = [];
    let passModel: any = {
      userid: ''
    };
    // this.XuserId = this.utilService.getFullUserId();
    // if (this.XuserId) {
    //   passModel.userid = this.XuserId;
    // } else {
    passModel.userid = this.utilService.getFullUserId();
    // }
    this.utilService.showSpinner()

    this.isLoading = true;
    // this.playlistService.getPlayList(passModel).subscribe((res: any) => {
    //   this.isLoading = false;
    //   this.utilService.hideSpinner()

    //   if (res.http_code == 200) {
    //     if (res.m3u) {
    //       res.m3u.map((ele: any) => {
    //         if (ele._id) {
    //           ele.isM3u = true;
    //           this.playList.push(ele);
    //         }
    //       });
    //     }
    //     if (res.xstream) {
    //       res.xstream.map((ele: any) => {
    //         ele.isXstream = true;
    //         this.playList.push(ele);
    //       });

    //     }
    //     console.log(this.playList);
    //   }
    // }, err => {
    //   this.isLoading = false;
    //   this.utilService.hideSpinner()

    //   this.utilService.showErrorCall(err);
    // });
    this.playlistService.getNewPlaylist().subscribe((res:any) =>{
      if(res.status === 'success'){
        console.log(res);
        this.playList = res.data;
        this.showCloudUpload = this.playList.length;
        console.log(this.showCloudUpload,'cloud length');
        
        this.filterPlayList = res.data
        this.isLoading = false;
        const localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        this.filterPlayList = [...this.filterPlayList, ...localPlaylists];
      console.log(this.filterPlayList,'asdf');
        this.utilService.hideSpinner();
      }
    },err =>{
      this.isLoading = false;
      this.utilService.hideSpinner();
    })
  }
  getLocalPlaylist(){
    const localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
    this.filterPlayList = localPlaylists;
    console.log(localPlaylists);
    
  }

  checkDuplicateName(name) {
    let found = false;
    const inputName = name.toLowerCase();
    for (let index = 0; index < this.filterPlayList.length; index++) {
      const existingName = this.filterPlayList[index].playlist_name.toLowerCase();
      if (existingName === inputName) {
        found = true;
        this.utilService.showErrorToast('', 'Playlist name must be unique');
        break;
      }
    }
    return !found;
  }
  
  

  addPlaylistM3u(form: NgForm) {
    if (form.valid && this.checkDuplicateName(this.playListModal.name)) {
      let passModel: any = {
        type:2,
        url: this.playListModal.url,
        name: this.playListModal.name,
        // userid: this.utilService.getFullUserId()
      };
      this.isLoading = true;
      this.utilService.showSpinner()
      if(this.playList.length < 5  && this.userid){ 
        this.playlistService.addPlaylistM3u(passModel).subscribe((res: any) => {
          this.isLoading = false;
          this.utilService.hideSpinner()
  
          if (res.status == 'success') {
            this.utilService.showErrorSuccess('m3u playlist is added successfully');
            this.getPlayList();
            this.playListModal.url = '';
            this.playListModal.name = '';
            this.closeModal();
          }
        }, err => {
          this.isLoading = false;
          this.utilService.hideSpinner()
          this.utilService.showErrorToast(err.error.message); // show the error 
          
        });
      }else{
        const fakeResponse = {
          status: 'success',
          message: 'Playlist added successfully',
          data: {
            user_id: this.userid, // You can use a utility function or random ID
            playlist_name: passModel.name,
            type: passModel.type,
            reseller_code: null,
            m3u_url: passModel.url,
            username: null,
            password: null,
            epg: null,
            user_agent: null,
            updated_at: new Date().toISOString(),
            created_at: new Date().toISOString(),
            id: Date.now(),
            local:true
          }
        };
  
        let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        localPlaylists.push(fakeResponse.data);
        localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
        this.filterPlayList.push(fakeResponse.data);
        this.isLoading = false;
        this.utilService.hideSpinner();
        this.utilService.showErrorSuccess(fakeResponse.message);

        this.closeModal();
        this.playListModal = {
          type: 'fromUrl',
          name: '',
          userName: '',
          password: '',
          url: ''
        };
      }
    }
  }

  addPlaylistXstream(form: NgForm) {
    if (form.valid && this.checkDuplicateName(this.playListModal.name)) {
      let passModel: any = {
        type:1,
        url: this.playListModal.url,
        pwd: this.playListModal.password,
        name: this.playListModal.name,
        username: this.playListModal.userName
      };

      this.isLoading = true;
      this.utilService.showSpinner()
      if(this.playList.length < 5  && this.userid){
        this.playlistService.addNewXstreamPlaylist(passModel).subscribe((res: any) => {
          this.isLoading = false;
          this.utilService.hideSpinner()
  
          if (res.status == 'success') {
            // , res.status
            this.utilService.showErrorSuccess('xstream playlist is added successfully');
            this.getPlayList();
            this.closeModal();
            this.playListModal = {
              type: 'fromUrl',
              name: '',
              userName: '',
              password: '',
              url: ''
            };
          }
        }, err => {
          this.isLoading = false;
          this.utilService.hideSpinner()
  
          this.utilService.showErrorCall(err);
        });
      }else{
        const fakeResponse = {
          status: 'success',
          message: 'Playlist added successfully',
          data: {
            user_id: this.userid, // You can use a utility function or random ID
            playlist_name: passModel.name,
            type: passModel.type,
            reseller_code: null,
            dns: passModel.url,
            username: passModel.username,
            password: passModel.pwd,
            epg: null,
            user_agent: null,
            updated_at: new Date().toISOString(),
            created_at: new Date().toISOString(),
            id: Date.now(),
            local:true
          }
        };


        
        // let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        // localPlaylists.push(fakeResponse.data);
        // localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
        // this.filterPlayList.push(fakeResponse.data);
        // this.isLoading = false;
        // this.utilService.hideSpinner();
        // this.utilService.showErrorSuccess(fakeResponse.message);

        // this.closeModal();
        // this.playListModal = {
        //   type: 'fromUrl',
        //   name: '',
        //   userName: '',
        //   password: '',
        //   url: ''
        // };
        const url = this.createUrl(passModel.username,passModel.pwd,passModel.url)
        if(url){
          this.authService.validateURL(url).subscribe((res:any)=>{
            if(res){
              let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        localPlaylists.push(fakeResponse.data);
        localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
        this.filterPlayList.push(fakeResponse.data);
        this.isLoading = false;
        this.utilService.hideSpinner();
        this.utilService.showErrorSuccess(fakeResponse.message);

        this.closeModal();
        this.playListModal = {
          type: 'fromUrl',
          name: '',
          userName: '',
          password: '',
          url: ''
            };
            }
            
          },err =>{
           this.authService.validatePostURL(passModel).subscribe((res:any)=>{
            if(res){
              let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
              localPlaylists.push(fakeResponse.data);
              localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
              this.filterPlayList.push(fakeResponse.data);
              this.isLoading = false;
              this.utilService.hideSpinner();
              this.utilService.showErrorSuccess(fakeResponse.message);

              this.closeModal();
              this.playListModal = {
                type: 'fromUrl',
                name: '',
                userName: '',
                password: '',
                url: ''
              };
            }
           },err =>{
            this.isLoading = false;
            this.utilService.hideSpinner()
            this.utilService.showErrorToast('Please enter valid url ,username ,password')
           })
            
          })
        }

      }
    }
  }

  addPlaylistOnestream(form:NgForm) {
    if (form.valid && this.checkDuplicateName(this.playListModal.name)) {
      console.log(this.playListModal.name,'Name one stream');
      
      let passModel: any = {
        type:4,
        url: this.playListModal.url,
        pwd: this.playListModal.password,
        name: this.playListModal.name,
        username: this.playListModal.userName
      };

      this.isLoading = true;
      this.utilService.showSpinner()
      if(this.playList.length < 5  && this.userid){
        
        this.playlistService.addNewXstreamPlaylist(passModel).subscribe((res: any) => {
          this.isLoading = false;
          this.utilService.hideSpinner()
  
          if (res.status == 'success') {
            // , res.status
            this.utilService.showErrorSuccess('xstream playlist is added successfully');
            this.getPlayList();
            this.closeModal();
            this.playListModal = {
              type: 'fromUrl',
              name: '',
              userName: '',
              password: '',
              url: ''
            };
          }
        }, err => {
          this.isLoading = false;
          this.utilService.hideSpinner()
  
          this.utilService.showErrorCall(err);
        });

      }else{
        const fakeResponse = {
          status: 'success',
          message: 'Playlist added successfully',
          data: {
            user_id: this.userid, // You can use a utility function or random ID
            playlist_name: passModel.name,
            type: passModel.type,
            reseller_code: null,
            dns: passModel.url,
            username: passModel.username,
            password: passModel.pwd,
            epg: null,
            user_agent: null,
            updated_at: new Date().toISOString(),
            created_at: new Date().toISOString(),
            id: Date.now(),
            local:true
          }
        };
  
        let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        localPlaylists.push(fakeResponse.data);
        localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
        this.filterPlayList.push(fakeResponse.data);
        this.isLoading = false;
        this.utilService.hideSpinner();
        this.utilService.showErrorSuccess(fakeResponse.message);

        this.closeModal();
        this.playListModal = {
          type: 'fromUrl',
          name: '',
          userName: '',
          password: '',
          url: ''
        };
      }  
    }
  }

  deleteItem(id :any,islocal:boolean) {
    // ev.stopPropagation();
    // ev.preventDefault();
    this.messageService.confirm('Delete!', 'Are you sure you want to delete?')
      .subscribe((answer) => {
        if (answer === 'Yes') {
          let passModel: any = {
            // url: url,
            // type: type,
            // userid: this.utilService.getFullUserId()
            id:id,
            local:islocal
          };
          this.isLoading = true;
          this.utilService.showSpinner()
          console.log(passModel);
          if(passModel.local == true)
          {
          let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
          localPlaylists = localPlaylists.filter((item: any) => item.id !== passModel.id);
          localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
          this.filterPlayList = this.filterPlayList.filter(item => item.id !== passModel.id);
          this.isLoading = false;
          this.utilService.hideSpinner();
          this.getPlayList();
          this.utilService.showErrorSuccess('Playlist deleted from local storage.');
          }else{
            this.playlistService.deletePlaylistItem(passModel).subscribe((res: any) => {
              this.isLoading = false;
              this.utilService.hideSpinner()
              if (res.status == 'success') {
                this.utilService.showErrorSuccess('', res.status);
                this.getPlayList();
              }
              if(res.detail.http_code == 403){
                this.isLoading = false;
                this.utilService.hideSpinner()
                this.utilService.showErrorToast(res.detail.status)
              }
  
            },(err:any) =>{
              this.isLoading = false
                this.utilService.hideSpinner()
                this.utilService.showErrorToast(err.error.message);
                if(err.status == 403){
                }
            });
          }

        }
      });
      }
  
  cloudPlaylist(data: any) {
        this.isLoading = true;
        this.utilService.showSpinner();
      
        let passModel: any = {
          type: data.type,
          url: data.type == 2 ? data.m3u_url : data.dns,
          password: data.password,
          playlist_name: data.playlist_name,
          username: data.username,
          // playlist_id:data.id
        };
      
        console.log(passModel, 'passmodel');
      
        const request$ = data.type == 2
          ? this.playlistService.addPlaylistM3u(passModel)
          : this.playlistService.addNewXstreamPlaylist(passModel);
      
        request$.subscribe(
          (res: any) => {
            this.isLoading = false;
            this.utilService.hideSpinner();
      
            if (res.status == 'success') {
              this.utilService.showErrorSuccess('xstream playlist is added successfully');
              this.deleteLocalOnCloud(data.id, data.local);
              this.closeModal();
              this.playListModal = {
                type: 'fromUrl',
                name: '',
                userName: '',
                password: '',
                url: ''
              };
            }
          },
          err => {
            this.isLoading = false;
            this.utilService.hideSpinner();
            this.utilService.showErrorCall(err);
          }
        );
      }
      
  editPlaylists(data:any){
    let passModel: any = {
      type:data.type,
      url: data.dns,
      pwd: data.password,
      name: data.playlist_name,
      username: data.username
    };
    console.log(data,'edit playlist',passModel);
     
  }
  editPlaylist(data: any) {
    const passModel = {
      playlist_id:data.id,
      type: data.type,
      url: data.type == 2 ? data.m3u_url : data.dns,
      pwd: data.password,
      name: data.playlist_name,
      username: data.username,
      local:data.local || false
    };
    console.log(passModel);
    
  
    this.messageService.editPlaylistDialog(passModel).subscribe((editedData) => {
      console.log(editedData.name);
      
      if (this.checkDuplicateName(editedData.name)) {
      const editedPlaylist =
      {
        playlist_id:editedData.id,
        type: editedData.type,
        url: editedData.type == 2 ? editedData.m3u_url : editedData.dns,
        pwd: editedData.password,
        name: editedData.playlist_name,
        username: editedData.username,
        local: editedData.local || false
      }
      if (editedData) {
        // console.log('Updated Playlist:', editedData);
        if(editedData.local == true){
          if(editedData.type == 2){
            console.log('local ==>',editedData);
          }else{
          console.log('edit',editedData);
          
          }
          
        }else{
          console.log(editedPlaylist);
          const request$ = editedData.type == 2
          ? this.playlistService.addPlaylistM3us(editedData)
          : this.playlistService.addNewXstreamPlaylists(editedData);
        request$.subscribe(
          (res: any) => {
            this.isLoading = false;
            this.utilService.hideSpinner();
      
            if (res.status == 'success') {
              this.utilService.showErrorSuccess('xstream playlist is added successfully');
              this.getPlayList()
              this.playListModal = {
                type: 'fromUrl',
                name: '',
                userName: '',
                password: '',
                url: ''
              };
            }
          },
          err => {
            this.isLoading = false;
            this.utilService.hideSpinner();
            this.utilService.showErrorCall(err);
          }
        );
      }
        
      }
      }
    });
  }
  

  close(){
    const modalElement = document.getElementById('editPlaylistModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.hide();
    }
    
  }

  deleteLocalOnCloud(id :any,islocal:boolean){
    let passModel: any = {
      // url: url,
      // type: type,
      // userid: this.utilService.getFullUserId()
      id:id,
      local:islocal
    };
    if(passModel.local == true)
      {
      let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
      localPlaylists = localPlaylists.filter((item: any) => item.id !== passModel.id);
      localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
      this.filterPlayList = this.filterPlayList.filter(item => item.id !== passModel.id);
      this.isLoading = false;
      this.utilService.hideSpinner();
      this.getPlayList();
      this.utilService.showErrorSuccess('Playlist deleted from local storage.');
  }
  }

  closeModal() {
    this.bsModalRef.hide();
  }
  openModal(template: any) {
    this.bsModalRef = this.modalService.show(template, { class: 'modal-dialog-centered' });
  }

  onLogout() {
    this.utilService.logout(true);
  }

 async onSelectPlaylist(item: any) {
    let decodeUrl;
    // this.utilService.removeXsreamStorage();
    // this.utilService.removeFullModeStorage();
    // this.authService.saveEncryptedPassword(item.pwd);
    // if (item.isXstream) {
    // } else {
    //   decodeUrl = encodeURIComponent(item.url);
    //   this.router.navigate(['/watchlist'], { queryParams: { url: decodeUrl } });
    // }
    if(item.local == true){
      console.log(item);
      if(item.type == 2){
        decodeUrl = encodeURIComponent(item.m3u_url);
        this.router.navigate(['/watchlist'], { queryParams: { url: decodeUrl } });
      }else{
        if (item.appLogo) {
          this.utilService.saveValueStorage(Constant.APP_LOGO, item.appLogo);
        } else {
          this.utilService.removeLocalStorage(Constant.APP_LOGO);
        }

        if (item.appBackground) {
          this.utilService.saveValueStorage(Constant.APP_BACKGROUND, item.appBackground);
        } else {
          this.utilService.removeLocalStorage(Constant.APP_BACKGROUND);
        }
        await this.saveDb(item)

        // this.utilService.saveValueStorage(Constant.FULLUSERID_KEY, item.user_id);
        // this.utilService.saveValueStorage(Constant.FULLUSERNAME_KEY, item.username);
        // this.utilService.saveValueStorage(Constant.FULLPASSWORD_KEY, item.password);
        // this.utilService.saveValueStorage(Constant.FULLURL_KEY,  item.dns);
        //     const  total = await this.livetvService.loadLivetv();
        //     const categorieslive = await this.livetvService.loadLivetvCategories();
        //     const totalmovies = await this.moviesService.loadMovies();
        //     const moviescategories = await this.moviesService.loadCategories();
        //     const seriesCategory = await this.seriesService.loadCategories();
        //     const totalseries = await this.seriesService.loadSeries();
        // this.router.navigate(['/home']);
      }
    }
    else if(item.type == 2){
      // this.router.navigate(['/watchlist'])
      decodeUrl = encodeURIComponent(item.m3u_url);
      this.router.navigate(['/watchlist'], { queryParams: { url: decodeUrl } });
    }
    else{
      const url = this.createUrl(item.username,item.password,item.dns)
      if(url){
        this.authService.validateURL(url).subscribe((res:any)=>{
          if(res){
            console.log(res);
            // this.router.navigate(['/profile',item.id])
            this.router.navigate(['/profile'],{state:{id:item.id,playlist_name:item.playlist_name,username:item.username,password:item.password,dns:item.dns}})

          }
          
        },err =>{
         this.authService.validatePostURL(item).subscribe((res:any)=>{
          if(res){
            console.log(res.user_info);
            // this.utilService.saveValueStorage(Constant.FULLUSERID_KEY, item.user_id);
            // this.utilService.saveValueStorage(Constant.FULLUSERNAME_KEY, item.playlist_name);
            // this.utilService.saveValueStorage(Constant.FULLPASSWORD_KEY, item.password);
            // this.utilService.saveValueStorage(Constant.FULLURL_KEY,  item.dns);
            // this.router.navigate(['/home']);
            // this.router.navigate(['/profile',item.id])
            this.router.navigate(['/profile'],{state:{id:item.id,playlist_name:item.playlist_name,password:item.password,dns:item.dns}})
            
          }
         })
          
        })
      }
    }

  }

  async saveDb(item){
    try { 
          this.isLoadingdb = true;
          this.utilService.saveValueStorage(Constant.FULLUSERID_KEY, item.user_id);
          this.utilService.saveValueStorage(Constant.FULLUSERNAME_KEY, item.username);
          this.utilService.saveValueStorage(Constant.FULLPASSWORD_KEY, item.password);
          this.utilService.saveValueStorage(Constant.FULLURL_KEY,  item.dns);
          // await this.livetvService.loadLivetv();
          // await this.livetvService.loadLivetvCategories();
          // await this.moviesService.loadMovies();
          // await this.moviesService.loadCategories();
          // await this.seriesService.loadCategories();
          // await this.seriesService.loadSeries();
          const totalItems = this.loadingItems.length;
          let completed = 0;

          // LIVE TV
          this.currentLabel = 'Loading Live TV categories...';
          await this.livetvService.loadLivetvCategories();
          this.currentLabel = 'Loading Live TV streams...';
          await this.livetvService.loadLivetv();
          this.markLoaded(0, ++completed, totalItems);

          // MOVIES
          this.currentLabel = 'Loading Movie categories...';
          await this.moviesService.loadCategories();
          this.currentLabel = 'Loading Movies...';
          await this.moviesService.loadMovies();
          this.markLoaded(1, ++completed, totalItems);

          // SERIES
          this.currentLabel = 'Loading Series categories...';
          await this.seriesService.loadCategories();
          this.currentLabel = 'Loading Series...';
          await this.seriesService.loadSeries();
          this.markLoaded(2, ++completed, totalItems);

          this.currentLabel = 'All content loaded!';
          this.router.navigate(['/home']);

          this.router.navigate(['/home']);


        } catch (error) {
          console.error("Error loading data", error);
          localStorage.setItem('progressComplete','false')
          this.isLoadingdb = false;

        } finally {
          localStorage.setItem('progressComplete','true')
          this.isLoadingdb = false;
        }

  }

  markLoaded(index: number, completed: number, total: number) {
  this.loadingItems[index].loaded = true;
  this.loadingItems[index].progress = 100;
  this.overallProgress = Math.round((completed / total) * 100);
}

async wrapAndTrack(task: () => Promise<any>) {
  await task();
  this.progress += Math.round(100 / this.totalTasks);
  console.log(this.progress);
  
}

  navigateCode(){
    this.closeModal();
    this.router.navigate(['/code'])
  }


  createUrl(user:string,password:any,url:string){
    return  `${url}/player_api.php?username=${user}&password=${password}`
  }

  hideShowPassword() {
    if (this.type === 'password') {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }

  clearStorage(){
    this.utilService.logout()
  }

}